module.exports = __webpack_public_path__ + "static/media/Cart_delete.3e6ffeed.svg";